import { mainPath } from './config/serverConfig';

import RestMethods from './config/restMethods';

class AuthResources {
  constructor() {
    this.restMethods = new RestMethods();
  }

  login(user) {
    return this.restMethods.post(`${mainPath}/users`, user);
  }

  clear() {
    localStorage.clear();
  }

  setCurrentUser(user) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }
}

export default AuthResources;
